import React, {useMemo} from "react";
import {ChatMessage} from "../types/chat-message";
import {useChatContext} from "../hooks/use-chat-context";
import {useChatMetadataContext} from "../hooks/use-chat-metadata-context";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faVolumeSlash} from "@fortawesome/pro-solid-svg-icons";

export const ChatConversationListItem: React.FC<{conversationId: string, name: string, lastMessage?: ChatMessage, unreadCount: number, active: boolean, isPurged: boolean}> = props => {
  const {users, selectConversation} = useChatContext()
  const {getMetadata} = useChatMetadataContext()
  const metadata = useMemo(() => getMetadata(props.conversationId), [props.conversationId, getMetadata])

  const timeText = useMemo(() => {
    if (! props.lastMessage) {
      return ""
    }
    const t = props.lastMessage.timestamp
    const currentDate = Math.floor(new Date().getTime() / 1000 / 60 / 60 / 24)
    const messageDate = Math.floor(t.getTime() / 1000 / 60 / 60 / 24)
    const daysAgo = currentDate - messageDate
    if (daysAgo === 0) {
      return t.toLocaleTimeString('nl-NL', { hour: 'numeric', hour12: false, minute: '2-digit'})
    } else if (daysAgo === 1) {
      return 'Gisteren'
    } else {
      return t.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric'})
    }
  }, [props.lastMessage])

  const lastMessageText = useMemo(() => {
    if (! props.lastMessage){
      return "-"
    }
    const user = users.find(u => u.id === props.lastMessage!.userId)
    let text = props.lastMessage.file ? "Bijlage" : props.lastMessage.message
    if (user) {
      text = `${user.name.split(' ')[0]}: ${props.lastMessage.file ? "Bijlage" : props.lastMessage.message}`
    }
    return text.length > 30 ? text.substring(0, 30) + "…" : text
  }, [props.lastMessage, users])

  return <div className={`m-2 rounded-lg px-4 py-3 flex flex-col ${ props.active ? "bg-blue-500" : "hover:bg-blue-50"} cursor-pointer transition-all`} onClick={() => selectConversation(props.conversationId)}>
    <div className={"flex items-center justify-between"}>
      {/* Title */}
      <div className={`flex-1 font-bold ${props.active ? "text-white" : "text-black"} mb-2`}>{ props.name }</div>
      {/* Status */}
      {metadata?.is_muted && <>
        <div className={`${props.active ? "text-white" : "text-gray-500"} text-xs mr-2`}><FontAwesomeIcon icon={faVolumeSlash} /></div>
      </>}

      {/* Time */}
      <div className={`${props.active ? "text-white" : "text-gray-500"} text-xs`}>{ timeText }</div>
    </div>
    <div className={"flex items-center justify-between"}>
      {/* Last message */}
      <div className={`${props.active ? "text-white" : "text-gray-500"}`}>{ lastMessageText }</div>
      { props.isPurged && <>
        <div className={"bg-amber-400 px-1 rounded-full text-xs text-white flex items-center justify-center h-3 w-3"}></div>
      </>}
      { props.unreadCount > 0 && !props.active && <>
        <div className={"bg-blue-500 px-1 rounded-full text-xs text-white flex items-center justify-center"} style={{ minWidth: "1.5em", minHeight: "1.5em"}}>
          <span>{ props.unreadCount }</span>
        </div>
      </> }
    </div>
  </div>
}


